import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import RaisedButton from 'material-ui/RaisedButton';
import { Toolbar, ToolbarGroup, ToolbarTitle } from 'material-ui/Toolbar';
import ClearIcon from 'material-ui/svg-icons/content/clear';
import PairDeviceDialog from '../pair_device_dialog/pair_device_dialog';
import ChromecastButton from '../chromecast/button/chromecast_button';
import ChromecastIcon from '../chromecast/icon/chromecast_icon';
import COLORS from '../../theme/colors';
import './device_manager.scss';

export default class DeviceManager extends Component {
  static propTypes = {
    pairedDevices: PropTypes.array,
    loadDevices: PropTypes.func.isRequired,
    pairDevice: PropTypes.func.isRequired,
    unpairDevice: PropTypes.func.isRequired,
    pairing: PropTypes.bool,
  };
  static defaultProps = {
    pairing: false,
    pairedDevices: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      pairDialogOpen: false,
    };
  }

  componentWillMount() {
    this.props.loadDevices();
  }

  getDevices() {
    return this.props.pairedDevices
      .map((device) => {
        return (
          <Toolbar
            key={device.id}
            className="device"
            style={{
              backgroundColor: COLORS.white,
              borderBottom: `1px solid ${COLORS.blue}`,
            }}
          >
            <ToolbarGroup firstChild>
              { device.deviceName }
            </ToolbarGroup>
            <ToolbarGroup lastChild>
              <ClearIcon
                color={COLORS.gray}
                hoverColor={COLORS.black}
                className="remove-device"
                onClick={() => { this.props.unpairDevice(device.id); }}
              />
            </ToolbarGroup>
          </Toolbar>
        );
      });
  }

  openPairDialog() {
    this.setState({ pairDialogOpen: true });
  }

  closePairDialog() {
    this.setState({ pairDialogOpen: false });
  }

  render() {
    const chromecastEnabled = !!window.chrome && !!window.chrome.cast;
    const pairButtonProps = {
      label: 'Pair',
      primary: true,
      disabled: this.props.pairing,
      onClick: () => { this.openPairDialog(); },
    };

    return (
      <div className="device-manager">
        <Toolbar style={{ backgroundColor: COLORS.blue }}>
          <ToolbarGroup firstChild>
            <ToolbarTitle text="Devices" style={{ paddingLeft: '20px', color: COLORS.white }} />
          </ToolbarGroup>
          <ToolbarGroup lastChild>
            {
              chromecastEnabled &&
              <MediaQuery minDeviceWidth={376}>
                <ChromecastButton />
              </MediaQuery>
            }
            <MediaQuery minDeviceWidth={376}>
              <RaisedButton
                {...pairButtonProps}
                style={{ margin: '10px 24px' }}
              />
            </MediaQuery>

            {
              chromecastEnabled &&
              <MediaQuery maxDeviceWidth={375}>
                <ChromecastIcon />
              </MediaQuery>
            }
            <MediaQuery maxDeviceWidth={375}>
              <RaisedButton
                {...pairButtonProps}
                style={{ margin: '10px 12px' }}
              />
            </MediaQuery>
          </ToolbarGroup>
        </Toolbar>

        <div className="devices">
          {
            !this.props.pairedDevices.length
              ? 'No connected devices found.'
              : this.getDevices()
          }
        </div>

        <PairDeviceDialog
          open={this.state.pairDialogOpen}
          pairDevice={(code, name) => {
            return this.props.pairDevice(code, name)
              .then(() => {
                this.closePairDialog();
              });
          }}
          pairing={this.props.pairing}
          onRequestClose={() => { this.closePairDialog(); }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/device_manager/device_manager.jsx